import styled from "@emotion/styled";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import React from "react";
import { BasePrediction } from "./AutoCompleteDialog";

interface Props<T extends BasePrediction> {
  prediction: T;
  query: string;
  onClick: (prediction: T) => void;
}

function AutoCompletePrediction<T extends BasePrediction>(props: Props<T>) {
  const matches = match(props.prediction.title, props.query);
  const parts = parse(props.prediction.title, matches);

  return (
    <Root onClick={() => props.onClick(props.prediction)}>
      {props.prediction.renderLeading?.()}
      {parts.map((part, index) => (
        <Highlight key={index} highlight={part.highlight}>
          {part.text}
        </Highlight>
      ))}
    </Root>
  );
}

const Root = styled.p`
  padding: 12px;
  margin: 0;
`;

const Highlight = styled.span<{ highlight: boolean }>`
  font-weight: ${(props) => (props.highlight ? "bold" : "normal")};
`;

AutoCompletePrediction.Root = Root;
AutoCompletePrediction.Highlight = Highlight;

export default AutoCompletePrediction;
